<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2
          class="pl-2"
        >{{ editRoute ? $t('labels.edit_mitigating_barrier') : $t('labels.add_mitigating_barrier') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full p-0">
              <label>{{ $t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="mitigating_barrier_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.mitigating_barrier_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('mitigating_barrier_name') }}</span>
            </div>
            <div class="vx-col sm: w-full p-0 mt-5">
              <label>{{ $t('labels.topevents')}}</label>
              <v-select
                multiple
                class="mt-1"
                name="topevent"
                v-model="parent_id"
                :options="parentSection"
                :reduce="parentSection => parentSection.id"
                label="name"
                :closeOnSelect="false"
              />
            </div>
          </div>
          <div class="mt-6 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-mitigating-barrier"
              button="submit"
            >{{ editRoute ? $t('labels.update_mitigating_barrier') : $t('labels.add_mitigating_barrier') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      parentSection: [],
      parent_id: []
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getTopevents();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getMitigatingBarrier();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateMitigatingBarriers();
        }
      });
    },
    // API Integration for add-update designation
    async createUpdateMitigatingBarriers() {
      let input = {
        name: this.name,
        top_event_ids: this.parent_id
      };
      let url = this.editRoute
        ? "/mitigating-barriers/update/" + this.editRoute
        : "/mitigating-barriers/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-mitigating-barrier",
        true
      );
      if (response) {
        this.$router.push({ name: "Mitigatingbarriers" });
      }
    },
    async getMitigatingBarrier() {
      let response = await this.getHTTPGetResponse(
        "/mitigating-barriers/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let mitigating_barrier = data.mitigating_barrier;
        this.name = mitigating_barrier.name;
        let filteredSection = [];
        for (var i = 0; i < mitigating_barrier.top_events.length; i++) {
          filteredSection.push(mitigating_barrier.top_events[i].id);
        }
        this.parent_id = filteredSection;
      }
    },
    async getTopevents() {
      let input = {
        name: this.parent_id
      };
      let response = await this.getHTTPPostResponse("/top-events/list", input);
      if (response) {
        let top_events_req = response.data.top_events;
        let filteredSection = [];
        for (var i = 0; i < top_events_req.length; i++) {
          let obj = { id: top_events_req[i].id, name: top_events_req[i].name };
          filteredSection.push(obj);
        }
        this.parentSection = filteredSection;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>